var React = require('react');

function Menu (props) {
    return React.createElement("svg",props,[React.createElement("line",{"x1":"0.5","y1":"-0.5","x2":"17.5","y2":"-0.5","transform":"matrix(0.999999 0.00135332 -0.000600022 1 0 1)","stroke":"black","strokeLinecap":"round","key":0}),React.createElement("line",{"x1":"0.5","y1":"-0.5","x2":"17.5","y2":"-0.5","transform":"matrix(0.999999 0.00135332 -0.000600022 1 0 7.48828)","stroke":"black","strokeLinecap":"round","key":1}),React.createElement("line",{"x1":"0.5","y1":"-0.5","x2":"17.5","y2":"-0.5","transform":"matrix(0.999999 0.00135332 -0.000600022 1 0 13.9756)","stroke":"black","strokeLinecap":"round","key":2})]);
}

Menu.defaultProps = {"width":"18","height":"14","viewBox":"0 0 18 14","fill":"none"};

module.exports = Menu;

Menu.default = Menu;
